import { atom, selector } from "recoil";

export const TokenAtom = atom({
  key: "TokenAtom",
  default: {
    access: undefined,
    refresh: undefined,
  },
});

export const isLoginSelector = selector({
  key: "isLoginSelector",
  get: ({ get }) => {
    const token = get(TokenAtom);
    return !!token.access; // access가 존재하면 로그인 상태로 간주
  },
});

export const TokenInfo = atom({
  key: "TokenInfo",
  default: {
    id: undefined,
    is_superuser: undefined,
    first_name: undefined,
  },
});

export const TokenPush = atom({
  key: "TokenPush",
  default: {
    tokenPush: "",
  },
});

export const NewPhotoStates = atom({
  key: "NewPhotoStates",
  default: {
    count1: false,
    count2: false,
    count3: false,
  },
});
